import React from 'react'
import "./deleteRackComponentModal.css"

export const DeleteRackComponentModal = ({ rackName, rackDescription, onClose, deleteRack }) => {

    const handleDelete = () => {
        deleteRack()
        onClose()
    }
    return (
        <section className='delete-rack-cont'>
            <h3>Are you sure you want to <br /> delete this Rack?</h3>
            <div className="delete-rack-pCont">
                <p>Rack: <span>{rackName}</span></p>
                <p>Description: <span>{rackDescription}</span></p>
            </div>
            <div className='delete-rack-btnCont'>
                <button onClick={handleDelete}>Ok</button>
                <button onClick={onClose}>Cancel</button>
            </div>
        </section>
    )
}
